// extracted by mini-css-extract-plugin
export default {"single-compress":"single-compress_kSErH"};